<script>
  import { fly } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';

  export let visible;

  const dispatch = createEventDispatcher();

  const handleClick = () => {
    // dispatch('changePage', 'page1');
    dispatch('changePage', { page: 'page1' });
  };
</script>

{#if visible}
  <div
    class="feedback-intro feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}>
    <img src="images/logos/cesLogoGrey.svg" alt="CES Logo" class="centered" />
    <h1 class="main-heading center-heading">Feedback</h1>
    <p class="center-text">
      CES Environmental Instruments values it's customers and partners and we
      want to thank you taking the time to participate in the following survey
      and hope to work with you again very soon.
    </p>
    <button class="btn" on:click={handleClick}>Start Survey</button>
  </div>
{/if}
